import { ManageConfigImpl } from "../data/ManageConfigImpl";
import { IManageConfigRepository } from "../domain/repositories/IManageConfigRepository";
import { ManageConfigUseCase } from "../domain/useCases/ManageConfigUseCase";
import { ManageConfigViewModel } from "../presentation/viewModel/ManageConfigViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ManageConfigInjection extends InjectionModule {
  private static readonly manageConfigRepositoryToken = Symbol(
    "IManageConfigRepository",
  );
  private static readonly manageConfigUseCaseToken = Symbol(
    "ManageConfigUseCase",
  );
  private static readonly manageConfigViewModelToken = Symbol(
    "ManageConfigViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.manageConfigRepositoryToken,
      useClass: ManageConfigImpl,
    },
    {
      scope: "otherRepo",
      token: this.manageConfigUseCaseToken,
      useClass: ManageConfigUseCase,
    },
    {
      scope: "viewModel",
      token: this.manageConfigViewModelToken,
      useClass: ManageConfigViewModel,
    },
  ];

  static getRepo(): IManageConfigRepository {
    return this.resolve(this.manageConfigRepositoryToken);
  }

  static getUseCase(): ManageConfigUseCase {
    return this.resolve(this.manageConfigUseCaseToken);
  }
}
